import { createRouter, createWebHashHistory } from "vue-router";
import routes from './routes'

const router = createRouter({
  // history: ,createWebHashHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

  if (to.path == '/404') document.title = to.meta.title + ' - ' + '善行视频'

  next()
})

export default router;
